
export default {
  APIURL: process.env.VUE_APP_API_ENDPOINT, // 開発
  /** 注文状況など NDS のベースURL（環境ごとに .env で設定） */
  NDS_BASE_URL: process.env.VUE_APP_NDS_BASE_URL || 'https://nds.naturally-plus.com'
}



// WEBPACK FOOTER //
// ./src/config/config.js